import { useSelectorTyped } from 'common/store/useSelectorTyped';
import { Permissions } from 'common/store/types';
import { useFeatureFlags } from './useFeatureFlags';

interface RBACSettingsProps {
  permissions: Permissions;
  hasRBACEnabled: boolean;
}

export function useRBACSettings(): RBACSettingsProps {
  const permissions = useSelectorTyped(state => state.permissions);
  const featureFlags = useFeatureFlags();
  const hasRBACEnabled = featureFlags.role_based_access_control;

  return {
    permissions,
    hasRBACEnabled,
  };
}
